<header class="header">
    <button class="header__hamburger" (click)="onMenuToggle()" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
    </button>
    <div class="header__logo">
        <img class="header__logo-img" src="assets/images/datarails-logo.svg" alt="FinanceOS" />
    </div>
    <div class="header__spacer"></div>
    <div *ngIf="displayName$ | async as displayName" class="header__user" aria-label="Signed-in user">
        <i class="header__user-icon dr-icon-user" aria-hidden="true"></i>
        <span class="header__user-name">{{ displayName }}</span>
    </div>
</header>
